import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery } from '@grandvisionhq/common';

const ProductBlockGrid = ({ hasBigPromo , hasSmallPromo , children ,  })=>{
    const breakpoint = MediaQuery.useBreakpoint();
    const classNames = classnames('product-block-grid', {
        'product-block-grid--with-promos': hasBigPromo && hasSmallPromo,
        'product-block-grid--with-big-promo': hasBigPromo && !hasSmallPromo,
        'product-block-grid--single-promo': breakpoint === MediaQuery.BreakpointName.PHONE && (hasBigPromo && !hasSmallPromo || !hasBigPromo && hasSmallPromo),
        'product-block-grid--col-2': breakpoint === MediaQuery.BreakpointName.PHONE,
        'product-block-grid--col-3': breakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT || breakpoint === MediaQuery.BreakpointName.TABLET_LANDSCAPE,
        'product-block-grid--col-4': breakpoint === MediaQuery.BreakpointName.DESKTOP
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames
    }, children);
};

export { ProductBlockGrid };
//# sourceMappingURL=ProductBlockGrid.js.map
